import { defineComponent } from "vue";
// 企业微信 App 的 URL Scheme 前缀（Android/iOS 通用，微信内置浏览器内可能被拦截）
const WXWORK_SCHEME = "wxwork://";
// 企业微信官方站点：未安装时引导用户到官网选择对应平台下载
const WXWORK_DOWNLOAD_URL = "https://work.weixin.qq.com/";
export default defineComponent({
  name: "PlatformNotice",
  setup() {
    /** 尝试拉起企业微信 App；调用失败时引导下载 */
    const openWxWork = () => {
      try {
        window.location.href = WXWORK_SCHEME;
        // 拉起失败/未安装时，scheme 跳转会无效，延时后引导去下载页
        window.setTimeout(() => {
          window.location.href = WXWORK_DOWNLOAD_URL;
        }, 1500);
      } catch (e) {
        console.error("拉起企业微信失败：", e);
        download();
      }
    };
    /** 前往企业微信下载页 */
    const download = () => {
      window.location.href = WXWORK_DOWNLOAD_URL;
    };
    return {
      openWxWork,
      download
    };
  }
});